import { ReactiveVar } from '@apollo/client';
import { AvailableError } from './index';
export default function disposeErrors(errorsVar: ReactiveVar<AvailableError[] | null>) {
  return () => {
    errorsVar(null);
  };
}
